<template>
  <div v-if="visible" class="dialog-overlay" @click="handleOverlayClick">
    <div class="dialog-container" @click.stop>
      <!-- 关闭按钮 -->
      <button class="close-button" @click="handleClose">
        <img src="@/assets/common/icon_gray_close.png" alt="Close" style="height: 32px;width: 32px"/>
      </button>
      
      <!-- 内容区域 -->
      <div class="dialog-content">
        <!-- 图标和文字区域 -->
        <div class="content-header">
          <div class="icon-container">
            <div class="warning-icon">
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M7 0C3.134 0 0 3.134 0 7s3.134 7 7 7 7-3.134 7-7-3.134-7-7-7zm0 10.5c-.414 0-.75-.336-.75-.75s.336-.75.75-.75.75.336.75.75-.336.75-.75.75zm.75-3c0 .414-.336.75-.75.75s-.75-.336-.75-.75V4.5c0-.414.336-.75.75-.75s.75.336.75.75v3z" :fill="iconColor"/>
              </svg>
            </div>
          </div>
          
          <div class="text-content">
            <h3 class="dialog-title">{{ title }}</h3>
            <p class="dialog-message" v-html="formattedMessage"></p>
          </div>
        </div>
      </div>
      
      <!-- 按钮区域 -->
      <div class="dialog-footer">
        <button class="cancel-button" @click="handleCancel">
          {{ cancelText }}
        </button>
        <button class="confirm-button" @click="handleConfirm">
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CommonDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      default: 'info',
      validator: function (value) {
        return ['info', 'error'].indexOf(value) !== -1
      }
    },
    title: {
      type: String,
      default: 'Notification'
    },
    message: {
      type: String,
      default: 'Please read and agree to the SICHUAN AIRLINES Privacy Policy before proceeding with the login.'
    },
    confirmText: {
      type: String,
      default: 'Agree and Login'
    },
    cancelText: {
      type: String,
      default: 'Cancel'
    },
    closeOnOverlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    formattedMessage() {
      return this.message.replace(
        'SICHUAN AIRLINES Privacy Policy',
        '<span style="color: #D8000F;">SICHUAN AIRLINES Privacy Policy</span>'
      );
    },
    iconColor() {
      return this.type === 'error' ? '#D8000F' : '#FF7D00';
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
    },
    handleCancel() {
      this.$emit('cancel');
    },
    handleConfirm() {
      this.$emit('confirm');
    },
    handleOverlayClick() {
      if (this.closeOnOverlay) {
        this.handleClose();
      }
    }
  }
};
</script>

<style lang="less" scoped>
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.dialog-container {
  position: relative;
  background: #FFFFFF;
  border-radius: 16px;
  box-shadow: 0px 4px 24px 0px rgba(136, 104, 87, 0.08);
  width: 328px;
  max-width: 90vw;
  max-height: 90vh;
  overflow: hidden;
  animation: dialogFadeIn 0.3s ease-out;
}

@keyframes dialogFadeIn {
  from {
    opacity: 0;
    transform: scale(0.9) translateY(-20px);
  }
  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.close-button {
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  z-index: 1;
  

}

.dialog-content {
  padding: 24px 24px 8px;
}

.content-header {
  display: flex;
  gap: 8px;
  align-items: flex-start;
}

.icon-container {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2px;
}

.warning-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.text-content {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 8px;
  width: 218px;
}

.dialog-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 16px;
  line-height: 1.5em;
  color: #333333;
  margin: 0;
  height: 24px;
  display: flex;
  align-items: center;
}

.dialog-message {
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.57em;
  color: #808080;
  margin: 0;
  word-wrap: break-word;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  background: #FFFFFF;
}

.cancel-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  height: 32px;
  background: transparent;
  border: none;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.57em;
  color: rgba(0, 0, 0, 0.65);
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: rgba(0, 0, 0, 0.04);
  }
  
  &:active {
    transform: scale(0.98);
  }
}

.confirm-button {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  padding: 6px 16px;
  height: 32px;
  background: #D8000F;
  border: none;
  border-radius: 6px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  line-height: 1.57em;
  color: #FFFFFF;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background: #B8000D;
  }
  
  &:active {
    transform: scale(0.98);
  }
}

// 响应式设计
@media (max-width: 480px) {
  .dialog-container {
    width: 90vw;
    margin: 20px;
  }
  
  .dialog-content {
    padding: 20px 20px 8px;
  }
  
  .dialog-footer {
    padding: 12px 20px;
  }
  
  .text-content {
    width: auto;
  }
}
</style>
